import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { createAxiosInstance } from "../axiosSettings";
import { logout } from "./authSlice";

const initialState = {
  isLoading: false,
  promotions : [],
  promotionData : null,
  promotionMessage : null,
  error : null
};


export const PROMOTION_URL = "/admin/promotion";

export const getPromotions = createAsyncThunk(
    PROMOTION_URL + "/get",
    async (formData, { rejectWithValue }) => {
      const axiosInstance = await createAxiosInstance();
      try {
        const response = await axiosInstance.get(PROMOTION_URL, {
          params: formData
        });
        if (response.data) {
          return response.data;
        } else {
          return rejectWithValue(response.data.message || "Error");
        }
      } catch (error) {
        return rejectWithValue(
          error.response?.data?.message || "Error"
        );
      }
    }
);

export const getPromotionById = createAsyncThunk(
  PROMOTION_URL + "/get-by-id",
  async (id, { rejectWithValue }) => {
    const axiosInstance = await createAxiosInstance();
    try {
      const response = await axiosInstance.put(`${PROMOTION_URL}/${id}`);
      if (response.data) {
        return response.data?.data;
      } else {
        return rejectWithValue(response.data.message || "Error");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error"
      );
    }
  }
);

export const createPromotion = createAsyncThunk(
    PROMOTION_URL + "/create",
    async (formData, { rejectWithValue }) => {
      const axiosInstance = await createAxiosInstance();
      try {
        const response = await axiosInstance.post(PROMOTION_URL, formData);
        if (response.data) {
          return response.data;
        } else {
          return rejectWithValue(response.data || "Error");
        }
      } catch (error) {
        return rejectWithValue(
          error.response?.data || "Error"
        );
      }
    }
);

export const updatePromotion = createAsyncThunk(
  PROMOTION_URL + "/update",
  async (formData, { rejectWithValue }) => {
    const axiosInstance = await createAxiosInstance();
    try {
      const response = await axiosInstance.put(PROMOTION_URL + "/" + formData?.id, formData);
      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue(response.data.message || "Error");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Error"
      );
    }
  }
);

export const deletePromotion = createAsyncThunk(
  PROMOTION_URL + '/delete',
  async (id, { rejectWithValue }) => {
    const axiosInstance = await createAxiosInstance();
    try {
      // const id = formData.get('id')
      const response = await axiosInstance.delete(PROMOTION_URL + '/' + id);
      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue(response.data || "Error");
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Error"
      );
    }
  }
);

const promotionSlice = createSlice({
    name : "promotion",
    initialState,
    extraReducers : (builder) => {
        builder
            .addCase(getPromotions.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getPromotions.fulfilled, (state, action) => {
                state.isLoading = false;
                state.promotions = action.payload;
            })
            .addCase(getPromotions.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })

            .addCase(getPromotionById.pending, (state) => {
              state.isLoading = true;
              state.error = null;
            })
            .addCase(getPromotionById.fulfilled, (state, action) => {
                state.isLoading = false;
                state.promotionData = action.payload;
            })
            .addCase(getPromotionById.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })

            .addCase(createPromotion.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(createPromotion.fulfilled, (state, action) => {
                state.isLoading = false;
                state.promotionData = action.payload;
            })
            .addCase(createPromotion.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })

            .addCase(updatePromotion.pending, (state) => {
              state.isLoading = true;
              state.error = null;
            })
            .addCase(updatePromotion.fulfilled, (state, action) => {
                state.isLoading = false;
                state.promotionData = action.payload;
            })
            .addCase(updatePromotion.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })

            .addCase(deletePromotion.pending, (state) => {
              state.isLoading = true;
              state.error = null;
            })
            .addCase(deletePromotion.fulfilled, (state, action) => {
                state.isLoading = false;
                state.promotionMessage = action.payload;
            })
            .addCase(deletePromotion.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(logout, () => initialState)
    }
})

export default promotionSlice.reducer